"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSound = require("cccisd-sound");
var _volumeMedium = _interopRequireDefault(require("cccisd-icons/volume-medium"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ReadHtml = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function ReadHtml(props) {
    var _this;
    _classCallCheck(this, ReadHtml);
    _this = _callSuper(this, ReadHtml, [props]);
    _defineProperty(_this, "clearTasks", function () {
      _this.timeouts.forEach(function (timeout) {
        return clearTimeout(timeout);
      });
    });
    _defineProperty(_this, "play", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, accommodations, setParameters;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, accommodations = _this$props.accommodations, setParameters = _this$props.setParameters; // Start playing
            _context.next = 3;
            return (0, _cccisdSound.play)({
              url: _this.props.audio.url,
              onEnd: _this.stopped,
              onStop: _this.stopped
            });
          case 3:
            _this.sound = _context.sent;
            if (_this.mounted) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            // Set playing state
            _this.setState({
              isPlaying: true
            });
            if (accommodations.highlighting && _this._getTimings().length > 0) {
              _this._startHighlighting();
            }
            if (accommodations.masking && _this.props.allowMasking) {
              _this.setState({
                masked: false
              });
            }
            if (setParameters) {
              setParameters({
                isTalking: true
              });
            }
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              if (_this.sound.playing()) {
                _this.sound.once('end', resolve);
              } else {
                resolve();
              }
            }));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "stop", function () {
      if (_this.sound) {
        // Stop playing
        _this.sound.stop();

        // Set stopping state
        _this.setState({
          isPlaying: false
        });
        if (_this.props.setParameters) {
          _this.props.setParameters({
            isTalking: false
          });
        }
      }
      if (_this.resolveAutoplayPromise) {
        setTimeout(_this.resolveAutoplayPromise, 500);
      }
    });
    _defineProperty(_this, "stopped", function () {
      _this.stop();
      if (_this.props.onEnded) {
        _this.props.onEnded();
      }
    });
    _defineProperty(_this, "replay", function () {
      if (!_this.state.isPlaying && _this.props.clickplay) {
        _this.play();
      }
    });
    _defineProperty(_this, "_startHighlighting", function () {
      _this.startTime = Date.now();
      _this._highlightTimeout();
    });
    _defineProperty(_this, "_highlightTimeout", function () {
      var timeDiff = Date.now() - _this.startTime;
      _this._updateCurrentWord(timeDiff);
      var nextTimeout = _this._getNextBoundary(timeDiff);
      if (nextTimeout) {
        _this.timeouts.push(setTimeout(_this._highlightTimeout, nextTimeout - timeDiff + 1));
      } else {
        _this._stopHighlighting();
      }
    });
    _defineProperty(_this, "_stopHighlighting", function () {
      _this.setState({
        currentWord: -1
      });
    });
    _defineProperty(_this, "_getTimings", function () {
      var timings = _this.props.audio.wordTimings || [];

      // Sanitize to numbers
      for (var i = 0; i < timings.length; i++) {
        timings[i].start *= 1;
        timings[i].end *= 1;
      }
      return timings;
    });
    _defineProperty(_this, "_markUpTranscript", function () {
      var unhighlightedClass = _this.props.unhighlightedClass || _style["default"].unhighlighted;
      _this.markedUpTranscript = _this.props.transcript;

      // Convert &nbsp; to spaces
      var nbspRE = new RegExp('&nbsp;', 'ig');
      _this.markedUpTranscript = _this.markedUpTranscript.replace(nbspRE, ' ');

      // Wrap words (that aren't in tags) with unhighlighted word span
      var wordRE = new RegExp('([^\\s>]+(?![^<]*>))', 'ig');
      _this.markedUpTranscript = _this.markedUpTranscript.replace(wordRE, '<span ' + ReadHtml.wordIdentifier + ' class="' + unhighlightedClass + '">$1</span>');
    });
    _defineProperty(_this, "_sortUnique", function (arr) {
      arr = arr.sort(function (a, b) {
        return a * 1 - b * 1;
      });
      var ret = [arr[0]];
      for (var i = 1; i < arr.length; i++) {
        if (arr[i - 1] !== arr[i]) {
          ret.push(arr[i]);
        }
      }
      return ret;
    });
    _defineProperty(_this, "_setupTimingsBoundaries", function () {
      var boundaries = [];
      var timings = _this._getTimings();
      timings.forEach(function (word) {
        boundaries.push(word.start);
        boundaries.push(word.end);
      });
      _this.timingsBoundaries = _this._sortUnique(boundaries);
    });
    _defineProperty(_this, "_getNextBoundary", function (currentOffset) {
      for (var i = 0; i < _this.timingsBoundaries.length; i++) {
        var boundary = _this.timingsBoundaries[i];
        if (boundary > currentOffset) {
          return boundary;
        }
      }
      return false;
    });
    _defineProperty(_this, "_findCurrentWord", function (currentOffset) {
      var timings = _this._getTimings();
      for (var i = 0; i < timings.length; i++) {
        if (timings[i].start <= currentOffset && timings[i].end >= currentOffset) {
          return i + 1;
        }
      }
      return -1;
    });
    _defineProperty(_this, "_updateCurrentWord", function (currentOffset) {
      var currentWord = _this._findCurrentWord(currentOffset);
      if (currentWord !== _this.state.currentWord) {
        _this.setState({
          currentWord: currentWord
        });
      }
    });
    _defineProperty(_this, "_getTranscript", function () {
      var currentWord = _this.state.currentWord;
      var highlightedClass = _this.props.highlightedClass || _style["default"].highlighted;
      var unhighlightedClass = _this.props.unhighlightedClass || _style["default"].unhighlighted;
      var transcript = _this.markedUpTranscript;

      // unhighlight everything
      var highlightedRE = new RegExp(ReadHtml.wordIdentifier + ' class="' + highlightedClass + '"', 'ig');
      transcript = transcript.replace(highlightedRE, ReadHtml.wordIdentifier + ' class="' + unhighlightedClass + '"');
      var nth = 0;

      // highlight current word if there is one
      if (currentWord >= 1) {
        var unhighlightedRE = new RegExp(ReadHtml.wordIdentifier + ' class="' + unhighlightedClass + '"', 'ig');
        var highlightReplace = ReadHtml.wordIdentifier + ' class="' + highlightedClass + '"';
        transcript = transcript.replace(unhighlightedRE, function (match) {
          return ++nth === currentWord ? highlightReplace : match;
        });
      }
      return transcript;
    });
    _defineProperty(_this, "_showPlayButton", function () {
      return !!(_this.props.audio.url && _this.props.showPlayButton);
    });
    _this.timeouts = [];
    _this.startTime = 0;
    _this.markedUpTranscript = '';
    _this.timingsBoundaries = [];
    _this.state = {
      masked: false,
      currentWord: -1,
      isPlaying: false
    };
    return _this;
  }
  _inherits(ReadHtml, _React$Component);
  return _createClass(ReadHtml, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        accommodations = _this$props2.accommodations,
        registerAction = _this$props2.registerAction;
      this.mounted = true;
      if (accommodations.masking && this.props.allowMasking) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          masked: true
        });
      }
      if (registerAction) {
        var action = this.getAction();
        registerAction(action);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      if (this.sound) {
        this.sound.off();
        this.sound.stop();
      }
      this.clearTasks();
      if (this.rejectAutoplayPromise) {
        this.rejectAutoplayPromise();
      }
    }
  }, {
    key: "getAction",
    value: function getAction() {
      var $this = this;
      var accommodations = this.props.accommodations;
      return {
        play: function play() {
          return new Promise(function (resolve, reject) {
            $this.rejectAutoplayPromise = reject;
            $this.resolveAutoplayPromise = resolve;
            $this.play();
          });
        },
        stop: function stop() {
          $this.stop();
        },
        autoplay: !!(accommodations.autoplayQuestions || accommodations.autoplayChoices)
      };
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.audio.wordTimings) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          onClick: this.replay,
          className: _style["default"].playable
        }, this.props.reactContent);
      }
      this._markUpTranscript();
      this._setupTimingsBoundaries();
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: this._showPlayButton() ? _style["default"].wrapper : ''
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].textWrapper,
        dangerouslySetInnerHTML: {
          __html: this._getTranscript()
        },
        onClick: this.replay
      }), this._showPlayButton() && /*#__PURE__*/_react["default"].createElement("a", {
        className: _style["default"].playButton + ' btn btn-secondary btn-xs',
        onClick: this.play
      }, /*#__PURE__*/_react["default"].createElement(_volumeMedium["default"], null)), this.state.masked && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].maskedContainer
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ReadHtml, "propTypes", {
  transcript: _propTypes["default"].string.isRequired,
  reactContent: _propTypes["default"].object.isRequired,
  audio: _propTypes["default"].object,
  clickplay: _propTypes["default"].bool,
  accommodations: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  allowMasking: _propTypes["default"].bool,
  showPlayButton: _propTypes["default"].bool,
  highlightedClass: _propTypes["default"].string,
  unhighlightedClass: _propTypes["default"].string
});
_defineProperty(ReadHtml, "defaultProps", {
  clickplay: false,
  accommodations: {},
  registerAction: null,
  onEnded: null,
  allowMasking: false,
  showPlayButton: false,
  highlightedClass: null,
  unhighlightedClass: null
});
// Something we can stash in HTML markup and be pretty sure it's a ReadHtml word
_defineProperty(ReadHtml, "wordIdentifier", 'data-readhtml="1"');